export default __webpack_public_path__ + "static/sprite-da6ed38d6cb2ffaa3381b5b417794302.svg";